import { planService } from '@/_services';
import router from '@/router'

export default {
  getAll({dispatch, commit}) {
    dispatch("alert/clear", {}, {root: true})
    planService.getAll()
      .then(
        planData => {
          commit("setPlanData", planData);
        },
        error => {
          dispatch("alert/error", error, {root: true});
        }
      )
  },
  switchPlan({dispatch, commit}, {planId, paymentMethod, aclChangeRole}) {
    dispatch("alert/clear", {}, {root: true})
    return planService.switchPlan(planId, paymentMethod)
      .then(
        response => {
          return dispatch("account/me", {aclChangeRole}, {root: true}).then(
            () => {
              return Promise.resolve(response);
            },
            () => {
              return Promise.resolve();
            }
          )
        },
        error => {
          /*dispatch("alert/error", error, {root: true});*/
          return Promise.reject(error);
        }
      )
  }
}
